import { supabase } from '../../lib/supabase';

/** Where Google sends the browser back to. Must be allow-listed in the
 *  Supabase dashboard (Authentication -> URL Configuration) for BOTH the
 *  production origin and http://localhost:5173, or the redirect is rejected. */
export function googleRedirectUrl(): string {
  return `${window.location.origin}/auth/callback`;
}

/**
 * Start the Google sign-in redirect.
 *
 * Deliberately the plain redirect flow, not a popup and not Google's GSI
 * script: a top-level navigation is not governed by the CSP's connect-src or
 * form-action, so no header change is needed — whereas loading
 * accounts.google.com/gsi/client would require widening script-src.
 * src/lib/supabase.ts already sets detectSessionInUrl, so the session is
 * picked up automatically when the browser lands back on /auth/callback.
 */
export async function signInWithGoogle(): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: googleRedirectUrl() },
  });
  if (error !== null) throw new Error(error.message);
}
